import React, { useState, useEffect } from "react";
import FilterableDashboardTemplate from "../../components/dashboardlayouts/FilterableDashboardTemplate";
import AmChartRingIndicator from "../../components/AmChartRingIndicator";
import DashboardGrid from "../../components/dashboardlayouts/DashboardGrid";
import DashboardRow from "../../components/dashboardlayouts/DashboardRow";
import DashboardCarousel from "../../components/dashboardlayouts/DashboardCarousel";
import RightDrawer from "../../components/dashboardlayouts/RightDrawer";
import { childDashboardsUtilisation } from "../../constants/dashboards-children";
import { CARD_STYLE_STRETCH } from "../../constants/styles";
import AmBarChart from "../../components/AmBarChart";
import AmHeatmapChart from "../../components/AmHeatmapChart";
import BookingUtilisationTimeline from "./components/BookingUtilisationTimeline";
import RoomBookingsDrawer from "./components/RoomBookingsDrawer";
import RoomBookingsDetailDrawer from "./components/RoomBookingsDetailDrawer";
import ChartCard from "../../components/ChartCard";
import { JWT } from "../../constants/local-storage";
import { functions } from "../../constants/common-functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    faTable
} from "@fortawesome/free-solid-svg-icons";


export default function RoomBookings() {
	
	const drawerContext=null;

    const [drawerOpen, setDrawerOpen] = useState(false);
	
	const [activities, setActivities] = useState([]);
	
	const [detailsOpen, setDetailsOpen] =
		        useState(false);

    const [drawerData, setDrawerData] =
        useState(null);

    const [dashboard, setDashboard] = useState(null);
	
	const [filter, setFilter] = useState({
	    buildingId: -100,
	    floorId: -100,
	    floorZoneId: -100,
	    organisationId: -100,
	    coreDayOnly: false,
	    startDate: null,
	    endDate: null
	});
	
	if (filter == null) {
	    filter = new RoomBookingFilter();
	}
	
	const summaryCard = {
		background:
		    "linear-gradient(135deg, #0f172a 0%, #111827 35%, #1e293b 100%)",
	    borderRadius: "4px",
	    padding: "16px",
	    height: "138px",        // 🔥 lock height
	    display: "flex",
	    alignItems: "center",
	    justifyContent: "center"
	};

	const summaryGrid = {
	    display: "grid",
	    gridTemplateColumns: "1fr 1fr",
	    width: "100%",
	    gap: "12px"
	};

	const summaryItem = {
	    borderLeft: "1px solid rgba(255,255,255,0.35)",   // 🔥 stronger
	    //borderBottom: "1px solid rgba(255,255,255,0.15)",
	    padding: "10px",
		gap:'16px'
	};

	const summaryValue = {
	    fontSize: "20px",
	    fontWeight: "600",
	    color: "#fff"
	};

	const summaryLabel = {
	    fontSize: "11px",
	    color: "#aaa",
	    marginTop: "4px"
	};
	
	
	const SHOW_BOOKINGS_BUTTON_STYLE = {

	    display: "flex",

	    alignItems: "center",

	    justifyContent: "center",

	    padding: "10px 18px",

	    border: "1px solid rgba(255,255,255,0.08)",

	    borderRadius: "12px",

	    background:
	        "linear-gradient(135deg, #111827 0%, #1f2937 100%)",

	    color: "#fff",

	    fontSize: "13px",

	    fontWeight: "600",

	    letterSpacing: "0.02em",

	    cursor: "pointer",

	    boxShadow:
	        "0 8px 20px rgba(0,0,0,0.18)",

	    backdropFilter: "blur(8px)",

	    transition:
	        "transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease"
	};

    // -----------------------------
    // LOAD DATA
    // -----------------------------
	useEffect(function () {

	    loadDashboard();

	}, [filter]);
	
	useEffect(function () {

	    functions.getObjectFromAjax(
	        "/resolutionsoftwareplatform/usageinspector/usageactivities",
	        setActivities,
	        null
	    );

	}, []);

	function loadDashboard() {

	    const token = localStorage.getItem(JWT);

	    fetch("/resolutionsoftwareplatform/roombookingdashboard/get", {
	        method: "POST",
	        headers: {
	            "Authorization": "Bearer " + token,
	            "Content-Type": "application/json"
	        },
	        body: JSON.stringify(filter)   // 👈 THIS is the key bit
	    })
	    .then(function (response) {
	        return response.json();
	    })
	    .then(function (data) {
	        setDashboard(data);
	        console.log(data);
	    })
	    .catch(function (error) {
	        console.error("Error loading dashboard:", error);
	    });
	}

    // -----------------------------
    // DATA TRANSFORMS
    // -----------------------------

	function getDOWData() {

	    if (!dashboard
	        || !dashboard.breakdowns
	        || !dashboard.breakdowns.byDayOfWeek) {

	        return [];
	    }

	    var dowLabels = {
	        0: "S",
	        1: "M",
	        2: "T",
	        3: "W",
	        4: "T",
	        5: "F",
	        6: "S"
	    };

	    return dashboard.breakdowns.byDayOfWeek.map(function (item) {

	        return {
	            category: dowLabels[item.key],
	            value: item.value
	        };

	    });

	}

    function getTimelineData() {

        if (!dashboard || !dashboard.timeline || !dashboard.timeline.points) {
            return [];
        }

        return dashboard.timeline.points.map(function (p) {
            return {
                date: new Date(p.time),
                bookings: p.bookings,
                utilised: p.utilised,
                noShows: p.noShows,
                ghosts: p.ghosts
            };
        });
    }
	
	
	function getHourProfileData() {

	    if (!dashboard || !dashboard.breakdowns || !dashboard.breakdowns.byHour) {
	        return [];
	    }

	    return dashboard.breakdowns.byHour.map(function (item) {
	        return {
	            category: item.key,
	            value: item.value
	        };
	    });
	}

	function getOrganisationData() {

	    if (!dashboard || !dashboard.breakdowns || !dashboard.breakdowns.byOrganisation) {
	        return [];
	    }

	    return dashboard.breakdowns.byOrganisation.map(function (item) {
	        return {
	            category: item.key,
	            value: item.value
	        };
	    });
	}

	function getNoShowOffenders() {

	    if (!dashboard || !dashboard.offenders || !dashboard.offenders.noShowRooms) {
	        return [];
	    }

	    return dashboard.offenders.noShowRooms.map(function (item) {
	        return {
	            category: item.name,
	            value: item.value
	        };
	    });
	}

	function getGhostOffenders() {

	    if (!dashboard || !dashboard.offenders || !dashboard.offenders.ghostRooms) {
	        return [];
	    }

	    return dashboard.offenders.ghostRooms.map(function (item) {
	        return {
	            category: item.name,
	            value: item.value
	        };
	    });
	}
	
	
	function getHeatmapData() {

	    if (!dashboard || !dashboard.heatmaps || !dashboard.heatmaps.bookings) {
	        return [];
	    }

	    return dashboard.heatmaps.bookings.map(function (item) {

	        return {
	            hour: item.categoryY,
	            day: item.categoryX,
	            value: item.value * 5   // 🔥 tweak this (3–10 range)
	        };
	    });
	}
	
	
	function SummaryItem(props) {

	    return (
	        <div style={summaryItem}>
	            <div style={summaryValue}>{props.value}</div>
	            <div style={summaryLabel}>{props.label}</div>
	        </div>
	    );
	}
	
	
	var summary = dashboard && dashboard.summary ? dashboard.summary : null;

    // -----------------------------
    // RENDER
    // -----------------------------

    return (
        <FilterableDashboardTemplate
            title="Room Bookings"
            childDashboards={childDashboardsUtilisation}
			filter={filter}
			setFilter={setFilter}
			
        >
			<DashboardGrid>
            {/* ---------------- RINGS ---------------- */}
			 <DashboardRow height={170}>

			  
				{/* ---------------- RINGS ---------------- */}
				<div style={{display: "flex", flex: 4, gap: "20px"}}>

				    <div style={CARD_STYLE_STRETCH}>
				        <AmChartRingIndicator
				            id="ring_booked"
				            percentage={dashboard && dashboard.rings ? dashboard.rings.avgBookedPercent : 0}
				            label="Booked %"
				            width={120}
				            height={120}
				            info="Percentage of available room-hours that were booked during the survey period."
				        />
				    </div>

				    <div style={CARD_STYLE_STRETCH}>
				        <AmChartRingIndicator
				            id="ring_utilised"
				            percentage={dashboard && dashboard.rings ? dashboard.rings.avgUtilisedPercent : 0}
				            label="Utilised %"
				            width={120}
				            height={120}
				            info="Percentage of booked hours where rooms showed signs of actual use (observed occupancy)."
				        />
				    </div>

				    <div style={CARD_STYLE_STRETCH}>
				        <AmChartRingIndicator
				            id="ring_noshow"
				            percentage={dashboard && dashboard.rings ? dashboard.rings.noShowPercent : 0}
				            label="No Show %"
				            width={120}
				            height={120}
				            info="Percentage of booked room-hours where no usage was observed during the booked time."
				        />
				    </div>

				    <div style={CARD_STYLE_STRETCH}>
				        <AmChartRingIndicator
				            id="ring_ghost"
				            percentage={dashboard && dashboard.rings ? dashboard.rings.ghostPercent : 0}
				            label="Ghost %"
				            width={120}
				            height={120}
				            info="Percentage of observed room usage that occurred without a corresponding booking."
				        />
				    </div>

				</div>

			    {/* ---------------- SUMMARY PANEL ---------------- */}
				<div style={summaryCard}>
				    
				    <div style={summaryGrid}>

					<SummaryItem label="Bookings" value={summary ? summary.totalBookings : 0} />
					<SummaryItem label="No Shows" value={summary ? summary.totalNoShows : 0} />
					<SummaryItem label="Observed" value={summary ? summary.totalObserved : 0} />
					<SummaryItem label="Ghosts" value={summary ? summary.totalGhosts : 0} />

				    </div>

				</div>
			   

			</DashboardRow>

            {/* ---------------- MID SECTION ---------------- */}
            <DashboardRow>

                <div style={{ flex: 2, alignItems: 'stretch' }}>
				<DashboardCarousel>

				    {/* ---------------- DAY OF WEEK ---------------- */}
				    <ChartCard title="By Day Of Week">
				        <AmBarChart
				            id="dow_chart"
				            data={getDOWData()}
				            categoryField="category"
				            valueField="value"
				        />
				    </ChartCard>

				    {/* ---------------- HOUR PROFILE ---------------- */}
				    <ChartCard title="Profile By Hour">
				        <AmBarChart
				            id="hour_chart"
				            data={getHourProfileData()}
				            categoryField="category"
				            valueField="value"
				        />
				    </ChartCard>

				    {/* ---------------- ORGANISATION ---------------- */}
				    <ChartCard title="By Organisation">
				        <AmBarChart
				            id="org_chart"
				            data={getOrganisationData()}
				            categoryField="category"
				            valueField="value"
				        />
				    </ChartCard>

				    {/* ---------------- NO SHOW OFFENDERS ---------------- */}
				    <ChartCard title="Top No Shows">
				        <AmBarChart
				            id="noshow_chart"
				            data={getNoShowOffenders()}
				            categoryField="category"
				            valueField="value"
				        />
				    </ChartCard>

				    {/* ---------------- GHOST OFFENDERS ---------------- */}
				    <ChartCard title="Top Ghosts">
				        <AmBarChart
				            id="ghost_chart"
				            data={getGhostOffenders()}
				            categoryField="category"
				            valueField="value"
				        />
				    </ChartCard>

				</DashboardCarousel>
                </div>

                <div style={{ flex: 1 }}>
                    <ChartCard title="Activity Heatmap">
					<AmHeatmapChart
					    id="heatmap"
					    data={getHeatmapData()}
					    color="#00bcd4"
					/>
                    </ChartCard>
                </div>

            </DashboardRow>

            {/* ---------------- TIMELINE ---------------- */}
            <DashboardRow>
			
			<ChartCard title="Timeline">
			<div
			    style={{
			        position:"absolute",
			        top:"18px",
			        right:"20px",
			        zIndex:50
			    }}
			>
			<button
			    style={SHOW_BOOKINGS_BUTTON_STYLE}
			    onClick={() => {

			       setDrawerOpen(true)

			    }}
			>
			    <FontAwesomeIcon
			        icon={faTable}
			        style={{
			            marginRight: "8px"
			        }}
			    />

			    Show Bookings
			</button>
			</div>
			    <BookingUtilisationTimeline
			        data={dashboard && dashboard.timeline ? dashboard.timeline.points : []}
			    />

			</ChartCard>

            </DashboardRow>
			</DashboardGrid>
            {/* ---------------- DRAWER ---------------- */}
            <RightDrawer
                open={drawerOpen}
                title="Details"
                onClose={() => setDrawerOpen(false)}
				width='450px'
            >
                <div>
				<RoomBookingsDrawer
				    filter={filter}
				    drawerContext={drawerContext}
					setDetailsOpen={setDetailsOpen}
					setDrawerData={setDrawerData}
				/>
                </div>
            </RightDrawer>
			<RoomBookingsDetailDrawer
				workplaceActivities={activities}
	              open={detailsOpen}
	              bookings={
	                  drawerData &&
	                  drawerData.bookings
	                      ? drawerData.bookings
	                      : []
	              }
	              daySummaries={
	                  drawerData &&
	                  drawerData.days
	                      ? drawerData.days
	                      : []
	              }
	              onClose={function () {
	
	                  setDetailsOpen(false);
	
	              }}
	          />
        </FilterableDashboardTemplate>
    );
}